import { applicationApi } from "../../common/api";
import { ContactUs } from "./types";

// Define a service using a base URL and expected endpoints
export const contactUsApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllContactUs: builder.query<ContactUs[], void>({
      query: () => `contact/message`,
      providesTags: [{ type: "ContactUs", id: "LIST" }],
    }),
    getContactUs: builder.query<ContactUs, string>({
      query: (query) => `contact/message/${query}`,
    }),
    updateContactUs: builder.mutation<ContactUs, any>({
      query: (body) => ({
        url: `/contact/message/${body.id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: [{ type: "ContactUs", id: "LIST" }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAllContactUsQuery, useGetContactUsQuery, useUpdateContactUsMutation } = contactUsApi;
